'use client';

import { c as _c } from "react/compiler-runtime";
import './base-carousel.css';
import './carousel.css';
import { type EmblaCarouselType, type EmblaOptionsType } from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback } from 'react';
import BlogCard from '@/features/blog/components/blog-card/blog-card';
import { type BlogPost } from '@/features/blog/types/blog-post-types';
import { NextButton, PrevButton, usePrevNextButtons } from '@/sections/blog-section/blog-buttons-arrow';
import { DotButton, useDotButton } from '@/sections/blog-section/blog-buttons-dot';
interface BlogCarouselProps {
  blogPosts: BlogPost[];
}
const OPTIONS: EmblaOptionsType = {
  align: 'start',
  loop: true
};
export default function BlogCarousel(props) {
  const $ = _c(32);
  const {
    blogPosts
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [Autoplay()];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS, t0);
  const onNavButtonClick = _temp;
  const {
    onDotButtonClick,
    scrollSnaps,
    selectedIndex
  } = useDotButton(emblaApi, onNavButtonClick);
  const {
    nextBtnDisabled,
    onNextButtonClick,
    onPrevButtonClick,
    prevBtnDisabled
  } = usePrevNextButtons(emblaApi, onNavButtonClick);
  let t1;
  if ($[1] !== blogPosts) {
    t1 = blogPosts.map(_temp2);
    $[1] = blogPosts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="embla__container">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== emblaRef || $[6] !== t2) {
    t3 = <div className="embla__viewport" ref={emblaRef}>{t2}</div>;
    $[5] = emblaRef;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onPrevButtonClick || $[9] !== prevBtnDisabled) {
    t4 = <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />;
    $[8] = onPrevButtonClick;
    $[9] = prevBtnDisabled;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== nextBtnDisabled || $[12] !== onNextButtonClick) {
    t5 = <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />;
    $[11] = nextBtnDisabled;
    $[12] = onNextButtonClick;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className="embla__buttons">{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onDotButtonClick || $[18] !== scrollSnaps || $[19] !== selectedIndex) {
    let t8;
    if ($[21] !== onDotButtonClick || $[22] !== selectedIndex) {
      t8 = (_, index) => <DotButton key={index} onClick={() => {
        onDotButtonClick(index);
      }} className={"embla__dot".concat(index === selectedIndex ? " embla__dot--selected" : "")} />;
      $[21] = onDotButtonClick;
      $[22] = selectedIndex;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t7 = scrollSnaps.map(t8);
    $[17] = onDotButtonClick;
    $[18] = scrollSnaps;
    $[19] = selectedIndex;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <div className="embla__dots">{t7}</div>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t6 || $[27] !== t8) {
    t9 = <div className="embla__controls">{t6}{t8}</div>;
    $[26] = t6;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t3 || $[30] !== t9) {
    t10 = <section className="embla theme-light">{t3}{t9}</section>;
    $[29] = t3;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}
function _temp2(post) {
  return <div className="embla__slide" key={post.id}><BlogCard blogPost={post} /></div>;
}
function _temp(api) {
  const {
    autoplay
  } = api.plugins();
  const resetOrStop = autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop;
  resetOrStop();
}